<script>
    import CreateUserComponent from "./CreateUserComponent.svelte";
    import {getContext} from "svelte";

    const { open } = getContext('simple-modal');

    export let model_root;

    let users = loadUsers();

    function openNewUserPanel() {
        open(CreateUserComponent, {
            model_root: model_root
        }, {}, {
            onClosed: () => {
            }
        });
    }

    function loadUsers() {
        return fetch(model_root + 'admin/user_management/get_users.php', {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

<table class="table table-hover table-responsive">
    <thead>
        <tr>
            <th scope="col">Nachname</th>
            <th scope="col">Vorname</th>
            <th scope="col">E-Mail Addresse</th>
            <th scope="col"></th>
        </tr>
    </thead>
    <tbody>
        {#await users}
            <p class="text-center mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Nutzer werden geladen...</p>
        {:then data}
            {#each data as user}
                <tr role="button">
                    <td>{@html user.uname}</td>
                    <td>{@html user.uprename}</td>
                    <td>{user.umail}</td>
                    <td>
                        {#if (user.ulastlogin === null) && (new Date(Date.parse(user.uhashvaliduntil.replace(/-/g, '/')))) < (new Date())}
                            <span class="text-danger"><i class="far fa-bell me-2"></i>Der Registrierungslink ist abgelaufen.</span>
                        {:else if user.ulastlogin === null}
                            <span class="text-warning"><i class="far fa-bell me-2"></i>Die Registrierung ist noch nicht abgeschlossen.</span>
                        {/if}
                    </td>
                </tr>
            {/each}
        {:catch error}
            <p style="color: red">{error.message}</p>
        {/await}
    </tbody>
</table>

<button class="btn btn-light" on:click={openNewUserPanel}>Neuen Nutzer anlegen</button>
